var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPercent = function SvgPercent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--c-basic-black)",
    strokeLinecap: "square",
    strokeWidth: 1.333,
    d: "M.943 22.276 22.277.943"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--c-basic-black)",
    strokeWidth: 1.333,
    d: "M6.634 1.92A3.334 3.334 0 1 1 1.92 6.633a3.334 3.334 0 0 1 4.714-4.715Zm14.667 14.666a3.333 3.333 0 1 1-4.712 4.713 3.333 3.333 0 0 1 4.712-4.713Z"
  })));
};
export default SvgPercent;